import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Modal, ModalManager } from './index';
import mySectionsData from './MySectionsData';

class RowSaveModal extends Component {

  getRowName(e){
    e.preventDefault();

    var name = this.refs.rowName.value;
    var row = this.props.row;

    var request = {
      'option' : 'com_sppagebuilder',
      'task' : 'page.saveSection',
      'title' : name,
      'section' : JSON.stringify(row)
    };

    jQuery.ajax({
      type   : 'POST',
      data   : request,
      success: function (response) {
          if(response != 'Failed'){
            mySectionsData.addSection({
              title: name,
              section: row,
              id: parseInt(response)
            });
  
            if(jQuery('.sp-pagebuilder-notifications').length === 0) {
              jQuery('<div class="sp-pagebuilder-notifications"></div>').appendTo('body')
            }
  
            jQuery('<div class="notify-success">' + 'Row saved!' + '</div>').css({
              opacity: 0,
              'margin-top': -15,
              'margin-bottom': 0
            }).animate({
              opacity: 1,
              'margin-top': 0,
              'margin-bottom': 15
            },200).prependTo('.sp-pagebuilder-notifications');
  
  
            jQuery('.sp-pagebuilder-notifications').find('>div').each(function() {
              var $this = jQuery(this);
  
              setTimeout(function(){
                $this.animate({
                  opacity: 0,
                  'margin-top': -15,
                  'margin-bottom': 0
                }, 200, function() {
                  $this.remove();
                });
              }, 3000);
            });
          } else {
            if(jQuery('.sp-pagebuilder-notifications').length === 0) {
              jQuery('<div class="sp-pagebuilder-notifications"></div>').appendTo('body')
            }
  
            jQuery('<div class="notify-error">' + 'Error: Unable to save Row!' + '</div>').css({
              opacity: 0,
              'margin-top': -15,
              'margin-bottom': 0
            }).animate({
              opacity: 1,
              'margin-top': 0,
              'margin-bottom': 15
            },200).prependTo('.sp-pagebuilder-notifications');
  
  
            jQuery('.sp-pagebuilder-notifications').find('>div').each(function() {
              var $this = jQuery(this);
  
              setTimeout(function(){
                $this.animate({
                  opacity: 0,
                  'margin-top': -15,
                  'margin-bottom': 0
                }, 200, function() {
                  $this.remove();
                });
              }, 3000);
            });
          }
      }
    });

    ModalManager.close();
  }

  render() {
    return(
      <Modal
        onRequestClose={this.props.onRequestClose}
        title="Save Row"
        customClass="sp-pagebuilder-modal-small sppb-modal-only-ext"
        openTimeoutMS={0}
        closeTimeoutMS={0}>
        {
          <div>
            <div className="sp-pagebuilder-form-group" style={{
                marginTop: '10px'
              }}>
              <input type="text" ref="rowName" name="row_name" id="row_name" className="sp-pagebuilder-form-control" placeholder="Enter name of this row" />
            </div>

            <div className="sp-pagebuilder-modal-actions">
              <a
                href="#"
                className="sp-pagebuilder-btn sp-pagebuilder-btn-success"
                onClick={ this.getRowName.bind(this) }><i className="fa fa-save"></i> {Joomla.JText._('COM_SPPAGEBUILDER_APPLY')}</a>
              <a
                href="#"
                className="sp-pagebuilder-btn sp-pagebuilder-btn-default"
                onClick={e=>{
                  e.preventDefault();
                  ModalManager.close()
                }}><i className="fa fa-times-circle"></i> {Joomla.JText._('COM_SPPAGEBUILDER_CANCEL')}
              </a>
            </div>
          </div>
        }
      </Modal>
    )
  }
}

export default RowSaveModal;



// WEBPACK FOOTER //
// ./src/helpers/RowSaveModal.js